export default __webpack_public_path__ + "static/media/S-011.8dc79938.png";